import { render, staticRenderFns } from "./SuccessEmailRecover.vue?vue&type=template&id=31a06291&"
import script from "./SuccessEmailRecover.vue?vue&type=script&lang=ts&"
export * from "./SuccessEmailRecover.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports